import React from "react";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import AdminHeaderVendorSelect from "./AdminHeaderVendorSelect";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    position: "relative",
  },
}));


export default function AdminHeader({
  ...props
}) {
  const classes = useStyles();
  
  return (
    <div className={classes.root}>
    <Grid
    container
    spacing={4}
    direction="row"
    alignItems="flex-start"
    justifyContent="flex-start"
    >
      <Grid item>
        <AdminHeaderVendorSelect props={props.appProps}/>
      </Grid>
    </Grid>
  </div>
  )
}
